// extracted by mini-css-extract-plugin
module.exports = {"container":"ev-pre-footer_container__P443E","preFooterImage":"ev-pre-footer_preFooterImage__R0Qt3"};